import { styled } from 'styled-components'
import { DSTextAndIcon } from '../TextAndIcon/TextAndIcon'
import { DSText } from '../DSText/DSText'

const StyledInfoBox = styled.div`
  padding: 12px;
  background-color: var(--colour-surface-purple-subtle);
  border-radius: var(--radius-8);

  &.welcome {
    background-color: var(--colour-surface-cream-subtle);
    border-radius: var(--radius-4);
  }

  &.error {
    background-color: var(--colour-surface-red-subtle);
    border: 1px solid var(--colour-border-error);
  }
`

interface InfoBoxProps {
  text: string
  variant?: string
}

const getIconName = (variant: string) => {
  switch (variant) {
    case 'welcome':
      return 'hand-wave-lines'
    default:
      return 'info-circle'
  }
}

const getTextVariant = (variant: string) => {
  switch (variant) {
    case 'welcome':
      return 'fluid-label-100'
    case 'info-small':
      return 'fluid-label-100'
    default:
      return 'fluid-paragraph-200'
  }
}

const getIconAndTextAlignment = (variant: string) => {
  switch (variant) {
    case 'welcome':
      return 'center'
    default:
      return 'flex-start'
  }
}

const withIcon = (variant: string) => {
  switch (variant) {
    case 'error':
      return false
    default:
      return true
  }
}

export const DSInfoBox = ({ variant = 'info', text }: InfoBoxProps) => {
  const showIcon = withIcon(variant)
  return (
    <StyledInfoBox className={variant ?? ''}>
      {showIcon && (
        <DSTextAndIcon
          iconName={getIconName(variant)}
          iconPosition="left"
          iconSize={16}
          text={text}
          textColour="primary"
          textVariant={getTextVariant(variant)}
          textWeight="lotaLight"
          iconAndTextAlignment={getIconAndTextAlignment(variant)}
        />
      )}
      {!showIcon && (
        <DSText colour="primary" variant={getTextVariant(variant)} weight="lotaLight">
          {text}
        </DSText>
      )}
    </StyledInfoBox>
  )
}
